<p-toast [baseZIndex]="1000" position="top-left"></p-toast>
<div class="container">
  <div class="card-panel mt-5">
    <div class="row">
      <div class="col-md-6 col-sm-4 pb-0 mb-0">
        <img src="assets/img/planejamento.png" alt="pesquisa" title="" height="32" width="32">
        <span *ngIf="grupo" class="titulo-txt-l pl-2">{{grupo.nome}}</span>
      </div>
      <div class="col-md-6 col-sm-8 pb-0 mb-0">
        <a [routerLink]="['/transparencia']" class="btn btn-sm btn-outline-secondary float-right ml-5">
          <img src="assets/img/global/cross.png" alt="sair" title="Sair" height="30" width="30">
        </a>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 pt-0 mt-0">
        <label style="font-weight: bold; color: #757575">
          {{login.orgao.codigo}} {{login.orgao.nome}}
        </label>
      </div>
    </div>
    <hr class="mt-1 mb-4" />
    <div class="row">
      <div class="col-sm-12 col-md-4 col-lg-5 col-xl-5 mr-0 pr-0">
        <lib-filtro [(filtro)]="filtro" (localizaClick)="onClick($event)" (localizaKeydown)="onClick($event)">
        </lib-filtro>
      </div>
    </div>
    <div class="row" *ngIf="lista.length > 0">
      <div class="col-md">
        <table class="table table-eddy" style="font-size: 13px;">
          <thead>
            <tr style="height: 42px;">
              <th scope="col" class="text-center">
                <a href="javascript:;" (click)="ordenar(1)" class="text-black-50">
                  <span *ngIf="col === 1"><img src="assets/img/global/{{imagem}}" alt="1" height="16"
                      width="16">&nbsp;</span>REFERÊNCIA
                </a>
              </th>
              <th scope="col">
                <a href="javascript:;" (click)="ordenar(2)" class="text-black-50">
                  <span *ngIf="col === 2"><img src="assets/img/global/{{imagem}}" alt="3" height="16"
                      width="16">&nbsp;</span>DESCRIÇÃO
                </a>
              </th>
              <th scope="col">
                <a href="javascript:;" (click)="ordenar(3)" class="text-black-50">
                  <span *ngIf="col === 3"><img src="assets/img/global/{{imagem}}" alt="4" height="16"
                      width="16">&nbsp;</span>NOME
                </a>
              </th>
              <th scope="col">
                <a href="javascript:;" (click)="ordenar(4)" class="text-black-50">
                  <span *ngIf="col === 4"><img src="assets/img/global/{{imagem}}" alt="5" height="16"
                      width="16">&nbsp;</span>GRUPO
                </a>
              </th>
              <th scope="col" class="text-right">
                <a href="javascript:;" (click)="ordenar(5)" class="text-black-50">
                  <span *ngIf="col === 5"><img src="assets/img/global/{{imagem}}" alt="7" height="16"
                      width="16">&nbsp;</span>TAMANHO
                </a>
              </th>
              <th scope="col" style="width: 90px;">

              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of lista">
              <td class="text-center">{{item.referencia}}</td>
              <td>{{item.descricao}}</td>
              <td>{{item.nome}}</td>
              <td>{{item.grupo.nome}}</td>
              <td class="text-right">{{item.tamanho}}</td>
              <td class="text-right">
                <a href="javascript:void" (click)="download(item)" class="btn btn-link">
                  Download
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="row float-right" *ngIf="lista && lista.length > 0">
      <div class="col-12 mb-5">
        <lib-paginacao [(paginaCorrente)]="paginaCorrente" [(paginaTotal)]="paginaTotal"
          (paginaAnterior)="paginaAnterior()" (proximaPagina)="proximaPagina()"></lib-paginacao>
      </div>
    </div>
    <br>
    <br>
    <div class="row" *ngIf="lista.length === 0">
      <div class="col-12 mt-5 ml-3">
        <img src="assets/img/global/warning.png" alt="atencao" class="mb-1">
        <br />
        <span style="color: #6a6a6a; font-weight: bold;">NÃO HÁ LANÇAMENTOS EFETUADOS NESTE PERÍODO! </span>
      </div>
    </div>
  </div>
</div>